import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 2H22V22H13V17H11V22H2V2H10V8.34186C10.3217 8.2281 10.6559 8.14096 11 8.08314V7H13V8.08311C13.3441 8.14092 13.6783 8.22804 14 8.34179V2ZM6 14C6 12.2224 6.77404 10.6256 8 9.52822V4H4V20H6V14ZM16 9.52826C17.2258 10.6256 18 12.2225 18 14V20H20V4H16V9.52826ZM8.12593 13H15.874C15.6447 12.1091 15.116 11.3379 14.3993 10.7995C13.7307 10.2972 12.9017 10 12 10C11.0985 10 10.2692 10.2973 9.60061 10.7995C8.88389 11.3379 8.35516 12.109 8.12593 13Z"}}]};

const Castle4Filled = Vue.extend<IconProps>({
  name: 'Castle4FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'castle-4-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Castle4Filled;
